<!-- 
Contents of the CONTACTS tab of the provider page.
-->
<template>
  <div>
    <our-heading 
      :next-page-action="nextPageAction"
      :previous-page-action="previousPageAction"
      :arrived-from-listing="arrivedFromListing"
      :breadcrumbs="breadcrumbs"
      :title="title"
      :subtitle="subtitle"
      user-guide-topic="listing-providers"
      user-guide-section="contacts"
      module="providers"
      nav-url="/providers/:id/contacts"
    />
    <tabs :provider-id="providerId">
      <provider-contact-listing :provider-id="providerId" />
    </tabs>
  </div>
</template>

<script>
import providerMixins from "./mixins";
import Tabs from "./Tabs.vue";
import ProviderContactListing from "@/components/provider-contacts/ProviderContactListing.vue";
import IncompleteContactsExplanation from "@/components/levy-collection-providers/IncompleteContactsExplanation.vue";

export default {
  name: "ProviderSummary",
  components: { ProviderContactListing, Tabs, IncompleteContactsExplanation },
  mixins: [providerMixins]
};
</script>
